module.exports = __webpack_public_path__ + "media/images/guide-2415996f9f3da8fd8477c9e7a6634d22.png";